var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditViewButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9305_15895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 11.3332L16 11.3398M16 15.9998L16 16.0065M16 20.6665L16 20.6732M16 11.9998C15.6318 11.9998 15.3333 11.7014 15.3333 11.3332C15.3333 10.965 15.6318 10.6665 16 10.6665C16.3682 10.6665 16.6667 10.965 16.6667 11.3332C16.6667 11.7014 16.3682 11.9998 16 11.9998ZM16 16.6665C15.6318 16.6665 15.3333 16.368 15.3333 15.9998C15.3333 15.6316 15.6318 15.3332 16 15.3332C16.3682 15.3332 16.6667 15.6316 16.6667 15.9998C16.6667 16.368 16.3682 16.6665 16 16.6665ZM16 21.3332C15.6318 21.3332 15.3333 21.0347 15.3333 20.6665C15.3333 20.2983 15.6318 19.9998 16 19.9998C16.3682 19.9998 16.6667 20.2983 16.6667 20.6665C16.6667 21.0347 16.3682 21.3332 16 21.3332Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9305_15895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditViewButton);
export default __webpack_public_path__ + "static/media/editViewButton.713f29421a9c40b5313feeb0f2841818.svg";
export { ForwardRef as ReactComponent };